"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const ChartHeader_1 = require("./ChartHeader");
const Previews_style_1 = require("../Previews.style");
const ChartCard = ({ chartType, isContentLoading, children, }) => {
    return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "p-none", children: (0, jsx_runtime_1.jsxs)(Previews_style_1.ChartContainer, { children: [(0, jsx_runtime_1.jsx)(ChartHeader_1.ChartHeader, { chartType: chartType, isContentLoading: isContentLoading }), isContentLoading && ((0, jsx_runtime_1.jsx)(Previews_style_1.ChartSpinnerWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, { size: "large" }) })), !isContentLoading && children] }) }));
};
exports.ChartCard = ChartCard;
